import { ContextAction, ContextActions, IContext } from "types";

// Context reducer
export default function reducer(state: IContext, action: ContextAction): IContext {
  switch (action.type) {
    case ContextActions.LOGIN: {
      localStorage.setItem("userData", JSON.stringify(action.value));
      return { ...state, userData: action.value, loadingUser: false };
    }
    case ContextActions.LOGOUT: {
      localStorage.removeItem("userData");
      return { ...state, userData: null, loadingUser: false };
    }
    case ContextActions.UPDATE_LOADING: {
      return { ...state, loadingUser: false };
    }
    case ContextActions.LOCALE: {
      localStorage.setItem("locale", action.value);
      return { ...state, locale: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action}`);
    }
  }
}
